import { axios, handleError } from "../../lib";
import { message } from "antd";

export const altSubAdmins = (data, actionType) => ({
  type: "ALT_SUBADMINS",
  data,
  actionType,
});

export const getAllSubAdmins =
  (force = false) =>
  async (dispatch, getState) => {
    try {
      if (!force) {
        const { subAdmins } = getState().dashStats;
        if (subAdmins && subAdmins.length > 0) {
          return;
        }
      }
      const response = await axios.get("/admin/users/all?type=sub_admin");
      if (response.data) {
        dispatch(altSubAdmins(response.data));
      }
    } catch ({ response }) {
      handleError(response);
    }
  };

export const createSubAdmin = (data) => async (dispatch) => {
  try {
    let payload = data;
    if (!(data instanceof FormData)) {
      payload = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          if (key === "image") {
            if (data[key] instanceof File) {
              payload.append("image", data[key]);
            }
          } else {
            payload.append(key, data[key]);
          }
        }
      });
    }

    const response = await axios.post("/admin/users/create-sub-admin", payload);
    if (response.status === "success") {
      await dispatch(getAllSubAdmins(true));
      message.success(response.details || "Successfully created User", 8);
      return {
        status: true,
      };
    } else {
      message.error(response.details || "Failed to create user", 8);
      return {
        status: false,
      };
    }
  } catch ({ response }) {
    handleError(response);
    return {
      status: false,
    };
  }
};
